import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../../../services/i18nService';
import stringUtils from '../../../../../../qti/utils/StringUtils';
import styles from './textCounter.scss';

const CharacterCounter = ({ text, maxChars }) => {
    const length = stringUtils.countChars(text);

    const LimitMessage = () => {
        return <span className={styles.limitMessage}>{t('essay.maxChars', { limit: maxChars })}</span>;
    };

    return (maxChars && maxChars > 0 && length >= maxChars) ? <LimitMessage /> : null;
};

CharacterCounter.propTypes = {
    text: PropTypes.string.isRequired,
    maxChars: PropTypes.number.isRequired,
};

export default CharacterCounter;
